import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
    standalone: true,
    selector: 'sh-collapsible',
    templateUrl: './collapsible.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule]
})
export class ShCollapsibleComponent implements OnChanges {
    private readonly animationDuration: number = 420; // Reference animation legnth in _collapsible.scss

    @Input() collapsed!: boolean;

    // This will control when content is actually removed from DOM
    public contentVisible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['collapsed']) {
            if (this.collapsed) {
                // When collapsing, delay content removal until after animation
                setTimeout(() => {
                    this.contentVisible$.next(false);
                }, this.animationDuration);
            } else {
                // When expanding, show content immediately
                this.contentVisible$.next(true);
            }
        }
    }
}
